import { submitInquiryToFirebase } from './firebaseService';

export interface InquirySubmission {
  name: string;
  phone: string;
  email?: string;
  propertyId?: string;
  propertyTitle?: string;
  serviceType?: string;
  preferredTime?: string;
  message?: string;
  source: 'property_modal' | 'contact_page' | 'consultation_modal';
}

/**
 * Handles full client inquiry workflow:
 * 1. Dispatches email to agency notification address (imotencentervarna1@gmail.com) via /api/inquiries
 * 2. Simultaneously archives in Firebase Firestore (collection "inquiries") for persistent lead tracking
 */
export async function sendClientInquiry(inquiry: InquirySubmission): Promise<{ success: boolean; message: string; emailSent?: boolean }> {
  // 1. Send to server backend to dispatch email to imotencentervarna1@gmail.com
  let emailDispatched = false;
  let emailErrorMsg: string | undefined = undefined;

  try {
    const res = await fetch('/api/inquiries', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(inquiry)
    });

    const resData = await res.json().catch(() => null);

    if (res.ok && resData?.success) {
      emailDispatched = true;
    } else {
      emailErrorMsg = resData?.error || resData?.message || `HTTP ${res.status}`;
      console.warn('Backend email API responded with error status:', res.status, resData);
    }
  } catch (apiErr: any) {
    emailErrorMsg = apiErr?.message || 'Network error';
    console.warn('Backend email API warning:', apiErr);
  }

  // 2. Archive in Firebase Firestore
  try {
    await submitInquiryToFirebase({
      name: inquiry.name,
      phone: inquiry.phone,
      email: inquiry.email || '',
      propertyId: inquiry.propertyId || '',
      propertyTitle: inquiry.propertyTitle || '',
      message: inquiry.message || (inquiry.serviceType ? `Интерес: ${inquiry.serviceType}` : ''),
      type: inquiry.source === 'consultation_modal' ? 'consultation' : (inquiry.source === 'property_modal' ? 'inspection' : 'contact'),
      emailStatus: emailDispatched ? 'sent' : 'failed',
      emailError: emailErrorMsg
    });
  } catch (fbErr) {
    console.warn('Firebase inquiry archiving warning:', fbErr);
  }

  return {
    success: true,
    emailSent: emailDispatched,
    message: 'Запитването беше прието успешно! Наш брокер ще се свърже с Вас в най-кратък срок.'
  };
}
